import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'videoUrl'
})
export class VideoUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(PromotionBackgroundVideoUrl: string, format: string): any {
    let url: string;
    if (format === 'background') {
      url = this.videoBgUrl(PromotionBackgroundVideoUrl);
    } else
      if (format === 'embed') {
        url = this.videoEmbedUrl(PromotionBackgroundVideoUrl);
      }
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  videoBgUrl(url: string) {
    let s_url = '';
    if (url.indexOf('youtu') > -1) {
      const delim = 'v=';

      s_url = '//www.youtube.com/embed/' + this.getIdFromYoutubeUrl(url)
        + '?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&playlist=' + this.getIdFromYoutubeUrl(url);

    } else if (url.indexOf('vimeo') > -1) {
      const delim = '/';
      s_url = '//player.vimeo.com/video/' + this.getIdFromVimeoUrl(url) + '?background=1';
    }
    return s_url;
  }

  videoEmbedUrl(url: string) {
    let s_url = '';
    if (url.indexOf('youtu') > -1) {
      const delim = 'v=';
      s_url = '//www.youtube.com/embed/' + this.getIdFromYoutubeUrl(url) + '?autoplay=1';
    } else if (url.indexOf('vimeo') > -1) {
      const delim = '/';
      s_url = '//player.vimeo.com/video/' + this.getIdFromVimeoUrl(url) + '?autoplay=1&title=0&byline=0&portrait=0';
    }
    return s_url;
  }

  getIdFromYoutubeUrl(url: string) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : false;
  }
  getIdFromVimeoUrl(url: string) {
    // tslint:disable-next-line:max-line-length
    const regExp = /https?:\/\/(?:www\.)?(?:player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
    const match = url.match(regExp);
    return match ? match[3] : false;
  }

}
